export const sidebarWidth = 215